import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CompanyCard from "./CompanyCard";
import Pagination from "../../common/Pagination";
import { ResultsFootActions } from "./SearchNotFoundActions";

export const SearchResults = ({ data, page = 1, setPage = () => { }, count, setShowPrompt = () => { },
  setSelectedPrompt = () => { }, }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 8;
  const location = useLocation();
  const totalPages = Math.ceil(data.length / resultsPerPage);
  const isPrompt = location.pathname.includes("prompt")
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const breakpoint = 768; // Set your breakpoint width here
  const [goToPage, setGoToPage] = useState("");
  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPage);
    if (pageNumber && pageNumber >= 1 && pageNumber <= totalPages) {
      handlePageChange(pageNumber);
      setGoToPage("");
    } else {
      alert("Invalid page number!");
    }
  };

  const isMobile = windowWidth < breakpoint;

  const handlePageChange = (page) => {
    setCurrentPage(page);
    scrollToTop();
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
    scrollToTop();
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    scrollToTop();
  };

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentResults = data.slice(startIndex, endIndex);

  const scrollToTop = () => {
    window.scrollTo({
      top: 150,
      behavior: "smooth",
    });
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value > totalPages) {
      const slicedValue = value?.slice(0, value?.length - 1);
      setGoToPage(slicedValue);
      return;
    }
    // Allow only numbers
    const newValue = value?.replace(/\D/g, '');
    setGoToPage(newValue);
  };

  return (
    <div>
      {currentResults.length > 0 &&
        currentResults.map((company, i) => (
          <div key={i}>
            <CompanyCard company={company} isPrompt={isPrompt} setShowPrompt={setShowPrompt}
              setSelectedPrompt={setSelectedPrompt} />
          </div>
        ))}

      {/* TIP-556 — the user has seen every result and still might not have
          found their company: offer claim / order-web-profile on the last page. */}
      {!isPrompt && currentResults.length > 0 && currentPage === totalPages && (
        <ResultsFootActions />
      )}

      {isPrompt ? <Pagination currentPage={page} totalPages={Math.ceil(count / 5)} onPageChange={(newPage) => setPage(newPage)} /> : !isMobile ? totalPages > 1 && data.length > resultsPerPage && (
        <div aria-label="Page navigation" className="mt-5">
          <ul className="inline-flex -space-x-px">
            <button
              className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
              disabled={currentPage === 1}
              onClick={currentPage === 1 ? null : handlePreviousPage}
            >
              <span className="sr-only">Previous</span>
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
            {Array.from({ length: totalPages }, (_, index) => index + 1).map(
              (page) => (
                <button
                  className={`px-3 py-2 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700 
                   ${currentPage === page ? "bg-footer text-white" : "bg-white"
                    }`}
                  key={page}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              )
            )}
            <button
              className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 
              "
              disabled={currentPage === totalPages}
              onClick={handleNextPage}
            >
              <span className="sr-only">Next</span>
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </ul>
        </div>
      ) :
        <>
          {totalPages > 1 && data.length > resultsPerPage && (
            <div aria-label="Page navigation" className="mt-5">
              <ul className="inline-flex -space-x-px">
                <button
                  className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
                  disabled={currentPage === 1}
                  onClick={handlePreviousPage}
                  style={{ display: isMobile ? "none" : "block" }}
                >
                  <span className="sr-only">Previous</span>
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                {isMobile ? (
                  <div className="flex flex-col">
                    <span className="mr-2">Page {currentPage} of {totalPages}</span>
                    <div>
                      <button
                        className={`px-3 py-2 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700 
                ${currentPage === 1 ? "bg-footer text-white" : "bg-white"
                          }`}
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {currentPage - 1}
                      </button>
                      <input
                        type="text"
                        className="border w-[40px] border-gray-300 px-2 py-1 text-center rounded"
                        value={goToPage}
                        max={totalPages}
                        onChange={handleInputChange}
                      />
                      <button
                        className={`px-3 py-2 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700 
                ${currentPage === totalPages ? "bg-footer text-white" : "bg-white"
                          }`}
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        {currentPage + 1}
                      </button>
                    </div>
                  </div>
                ) : (
                  Array.from({ length: totalPages }, (_, index) => index + 1).map(
                    (page) => (
                      <button
                        className={`px-3 py-2 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700 
                  ${currentPage === page ? "bg-footer text-white" : "bg-white"
                          }`}
                        key={page}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    )
                  )
                )}
                <button
                  className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 
            "
                  disabled={currentPage === totalPages}
                  onClick={handleNextPage}
                  style={{ display: isMobile ? "none" : "block" }}
                >
                  <span className="sr-only">Next</span>
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </ul>
              <div className="mt-2 flex justify-center items-center">
                <button
                  className="ml-2 px-3 py-1 bg-gray-300 text-white rounded hover:bg-gray-400"
                  onClick={handleGoToPage}
                >
                  Go
                </button>
              </div>
            </div>
          )}
        </>}
    </div>
  );
};
